declare global {
  interface Window {
    newrelic?: {
      setCustomAttribute: (name: string, value: string | number | boolean | null) => void;
    };
  }
}

interface NewRelicPageAttributes {
  pageType?: string;
  division?: string;
}

export const setNewRelicPageAttributes = ({ pageType, division }: NewRelicPageAttributes) => {
  if (typeof window === 'undefined' || !window.newrelic?.setCustomAttribute) {
    return;
  }

  if (pageType) {
    window.newrelic.setCustomAttribute('pageType', pageType);
  }

  if (division) {
    window.newrelic.setCustomAttribute('division', division);
  }
};
